import type { Components } from '@mui/material/styles';

export default function MUICardActions(): Components['MuiCardActions'] {
  return {};
}
